<template>
    <LsInfoRow
        class="ls-info-row-quote-completed"
        :left-image="require('./assets/calendar-check.svg')"
        label="Quote Completed"
        :value="value"
    >
        <v-popover v-if="getGeofence">
            <img :src="require('./assets/location.svg')" />
            <template slot="popover">
                <div class="ls-info-row-quote-completed--popover">
                    <span>GPS Verified At:</span><br />
                    <span>{{
                        time({
                            timestamp: getGeofence,
                        })
                    }}</span>
                </div>
            </template>
        </v-popover>
    </LsInfoRow>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { lsPropTypeHelpers } from 'ls-vue-common';
import LsInfoRow from '../LsInfoRow/LsInfoRow.vue';
import { lsHelpers } from '@/helpers';

const MANUAL_PRICE = 'manual_price';
const MANUAL_QUOTE = 'manualquote';
// Matches the placeholder the sibling pricing and status rows show.
const EMPTY_DISPLAY = '- - - -';

export default {
    name: 'LsInfoRowQuoteCompleted',
    components: {
        LsInfoRow,
    },
    props: {
        schedule: VueTypes.shape({
            __typename: VueTypes.string.isRequired,
            created_at: VueTypes.string,
            type: VueTypes.string,
            manualquote: VueTypes.shape({
                status: VueTypes.string.isRequired,
                price: VueTypes.oneOfType([
                    VueTypes.shape({
                        updated_at: VueTypes.string,
                    }).loose,
                    VueTypes.oneOfType([null]),
                ]),
            }).loose,
            last_completed_schedule_event: VueTypes.oneOfType([
                VueTypes.shape({
                    status_set_at: VueTypes.custom(lsPropTypeHelpers.stringOrNull).isRequired,
                    geofence: VueTypes.shape({
                        status_set_at: VueTypes.custom(lsPropTypeHelpers.stringOrNull).isRequired,
                    }).isRequired.loose,
                }).loose,
                VueTypes.oneOfType([null]),
            ]),
        }).isRequired.loose,
        quote: VueTypes.oneOfType([
            VueTypes.shape({
                setAt: VueTypes.oneOfType([VueTypes.string, VueTypes.oneOfType([null])]),
            }).loose,
            VueTypes.oneOfType([null]),
        ]).def(null),
        quoteLoading: VueTypes.bool.def(false),
    },
    computed: {
        isManualQuote() {
            return _.get(this.schedule, 'type') === MANUAL_QUOTE;
        },
        isManualPrice() {
            return (
                !this.isManualQuote && _.get(this.schedule, 'service.price_type') === MANUAL_PRICE
            );
        },
        manualPriceValue() {
            if (this.quoteLoading || _.isNil(this.quote)) {
                return EMPTY_DISPLAY;
            }

            const setAt = _.get(this.quote, 'setAt');

            return _.isNil(setAt) ? 'N/A' : this.time({ timestamp: setAt });
        },
        scheduleType() {
            return _.get(this.schedule, 'type') || _.get(this.schedule, '__typename');
        },
        value() {
            // Must stay first: on a manual price `scheduleType` is 'service', so the legacy
            // arms below would answer 'N/A'.
            if (this.isManualPrice) {
                return this.manualPriceValue;
            }

            if (this.scheduleType === 'Recommendation') {
                return this.time({ timestamp: this.schedule.created_at });
            }

            if (this.scheduleType === 'RequiredService') {
                return this.time({ timestamp: this.schedule.status_set_at });
            }

            const { status } = this.schedule[this.scheduleType];

            if (status === 'new' || !_.get(this.schedule[this.scheduleType], 'price.updated_at')) {
                return 'N/A';
            }

            return this.time({ timestamp: this.schedule[this.scheduleType].price.updated_at });
        },
        getGeofence() {
            return _.get(this.schedule, 'last_completed_schedule_event.geofence.status_set_at');
        },
    },
    methods: {
        time({ timestamp }) {
            return lsHelpers.parseTimestamp({
                timestamp,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-info-row-quote-completed--popover {
    width: 240px;
    color: $secondary-dark;
    line-height: 20px;
    :first-child {
        font-weight: $bold;
    }
}
</style>
